import { Injectable } from '@angular/core';
import { NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

import { Model } from '../models/clux/model-legacy';

@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {

  private readonly i18nValues: Model.II18N = {
    en: {
      weekdays: ['M', 'T', 'W', 'T', 'F', 'S', 'S'],
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    },
    // other languages you would support
  };
  constructor() {
    super();
  }
  public getWeekdayShortName(weekday: number): string {
    return this.i18nValues.en.weekdays[weekday - 1];
  }
  public getMonthShortName(month: number): string {
    return this.i18nValues.en.months[month - 1];
  }
  public getMonthFullName(month: number): string {
    return this.getMonthShortName(month);
  }
  public getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}-${date.month}-${date.year}`;
  }

  public getWeekdayLabel(weekday: number): string {
    return ['M', 'T', 'W', 'R', 'F', 'Sa', 'Su'][weekday - 1];
  }
}
